import { getAllNotifications } from "@/helpers/server-actions/notification-collection";
import { NotificationMessage } from "@/models/notification";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from '@/redux/store'; // adjust the path as necessary

type NotificationState = {
    notifications: NotificationMessage[];
};

const initialState: NotificationState = {
    notifications: [],
};

export const fetchNotifications = createAsyncThunk(
    'notification/fetchNotifications',
    async (_, { getState, rejectWithValue }) => {
        try {
            const state = getState() as RootState;
            const { notifications } = state.notificationReducer;

            if (notifications.length === 0) {
                const fetchedNotifications = await getAllNotifications();
                const readNotifications = JSON.parse(localStorage.getItem('readNotifications') || '[]');
                return fetchedNotifications.map(notification => {
                    notification.isRead = readNotifications.includes(notification.id);
                    return notification;
                });
            }
            return notifications;
        } catch (error) {
            return rejectWithValue('Failed to fetch notifications');
        }
    }
);

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setNotifications: (state, action: PayloadAction<NotificationMessage[]>) => {
            state.notifications = action.payload;
        },
        addNotification: (state, action: PayloadAction<NotificationMessage>) => {
            state.notifications.push(action.payload);

            // Sort notifications by date
            state.notifications.sort((a, b) => {
                return (b.timestamp ?? new Date()).getTime() - (a.timestamp ?? new Date()).getTime();
            });
        },
        markAsRead: (state, action: PayloadAction<string>) => {
            const notification = state.notifications.find(n => n.id === action.payload);
            if (notification) {
                notification.isRead = true;
            }
        },
        markAllAsRead: (state) => {
            state.notifications.forEach(notification => {
                notification.isRead = true;
            });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchNotifications.fulfilled, (state, action) => {
            state.notifications = action.payload;
        });
    }
});

export const { setNotifications, addNotification, markAsRead, markAllAsRead } = notificationSlice.actions;
export default notificationSlice.reducer;